export const isSSR = typeof window === 'undefined';
export const isNotSSR = !isSSR;
